import { render, staticRenderFns } from "./SatsangiProfileEdit.vue?vue&type=template&id=7b91ba60&"
import script from "./SatsangiProfileEdit.vue?vue&type=script&lang=js&"
export * from "./SatsangiProfileEdit.vue?vue&type=script&lang=js&"
import style0 from "./SatsangiProfileEdit.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports